import { extendTheme, Theme } from '@chakra-ui/react'
import { defaultComponentStyles } from '~/components/defaults/componentStyles'
import { layoutComponentStyles } from '~/components/layout/componentStyles/styles'
import { sharedComponentStyles } from '~/components/shared/componentStyles/_styles'
import { callsComponentStyles } from '~/pages/Calls/componentStyles/_styles'
import { contactsComponentStyles } from '~/pages/Contacts/componentStyles/_styles'
import { faxComponentStyles } from '~/pages/Fax/componentStyles/_styles'
import { homeComponentStyles } from '~/pages/Home/componentStyles/_styles'
import { callInProgressModalComponentStyles } from '~/pages/Home/Modals/CallInProgressModal/componentStyles/_styles'
import { confirmModalComponentStyles } from '~/pages/Home/Modals/ConfirmModal/componentStyles/_styles'
import { customStatusModalComponentStyles } from '~/pages/Home/Modals/CustomStatusModal/componentStyles/_styles'
import { newExtensionSubscriptionModalComponentStyles } from '~/pages/Home/Modals/NewExtensionSubscriptionModal/componentStyles/_styles'
import { newFaxModalComponentStyles } from '~/pages/Home/Modals/NewFaxModal/componentStyles'
import { newParkingLotModalComponentStyles } from '~/pages/Home/Modals/NewParkingLotModal/componentStyles/_styles'
import { newSpeedDialModalComponentStyles } from '~/pages/Home/Modals/NewSpeedDialModal/componentStyles/_styles'
import { siteNavigationComponentStyles } from '~/pages/Home/SiteNavigation/componentStyles/_styles'
import { topNavComponentStyles } from '~/pages/Home/TopNav/componentStyles'
import { loginComponentStyles } from '~/pages/Login/componentStyles/_styles'
import { messagingComponentStyles } from '~/pages/Messaging/componentStyles/_styles'
import { settingsComponentStyles } from '~/pages/Settings/componentStyles/_styles'
import { voicemailComponentStyles } from '~/pages/Voicemail/componentStyles/_styles'
import { phoneComponentStyles } from '~/pages/WebPhone/componentStyles/_styles'
import { MangoTheme, ThemeColorMode } from '~/themes'
import { colorPalette } from '~/themes/colors/colorPalette'
import { themeColorSections } from '~/themes/colors/colors'
import { textStyles } from '~/themes/textStyles/defaultTextStyles'
import { getMergedComponentStyles } from '~/utils/themeUtils'

const mergedStyles = getMergedComponentStyles({
  defaultComponentStyles,
  layoutComponentStyles,
  sharedComponentStyles,
  homeComponentStyles,
  siteNavigationComponentStyles,
  loginComponentStyles,
  contactsComponentStyles,
  faxComponentStyles,
  phoneComponentStyles,
  newExtensionSubscriptionModalComponentStyles,
  newFaxModalComponentStyles,
  newParkingLotModalComponentStyles,
  newSpeedDialModalComponentStyles,
  confirmModalComponentStyles,
  callInProgressModalComponentStyles,
  messagingComponentStyles,
  voicemailComponentStyles,
  settingsComponentStyles,
  topNavComponentStyles,
  callsComponentStyles,
  customStatusModalComponentStyles,
})

const mangoTheme: MangoTheme = {
  breakpoints: {
    base: '0rem',
    xxs: '29rem',
    xs: '47rem',
    sm: '62rem',
    md: '80rem',
    lg: '96rem',
    xl: '119rem',
    '2xl': '500rem',
  },
  textStyles,
  config: {
    initialColorMode: ThemeColorMode.default,
    useSystemColorMode: false,
  },
  colors: { ...colorPalette },
  semanticTokens: {
    colors: {
      ...themeColorSections,
    },
  },
  components: {
    ...mergedStyles,
  },
}

export const defaultTheme = extendTheme({
  ...mangoTheme,
  styles: {
    global: {
      input: {
        '&::-webkit-calendar-picker-indicator': {
          src: 'url(./svgs/icon-calendar.svg)',
        },
      },
      div: {
        '@supports (-moz-appearance:none)': {
          div: {
            scrollbarWidth: 'thin !important',
            scrollbarColor: `${colorPalette.gray[700]} ${colorPalette.achromatic.transparent}`,
          },
        },
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-track': {
          width: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
          width: '8px',
          borderRadius: '20px',
          border: '1px solid #FFF',
          opacity: 0.7,
          backgroundColor: colorPalette.gray[700],
        },
        '&.scrollbar-hidden': {
          '&::-webkit-scrollbar-thumb': {
            width: '8px',
            borderRadius: '20px',
            border: '1px solid transparent',
            backgroundColor: 'transparent',
          },
        },
      },
    },
  },
}) as MangoTheme & Theme
